import { useEffect } from 'react'
import * as store from '@store'
import { useWireValue } from '@forminator/react-wire'
import { useWireState } from '@forminator/react-wire'
import { RT_EVENT_TYPE_UPDATE_TITLE_BREAKDOWN_STATUS } from '@/constants/realtime'
import { fetchTitleBreakdown, listUniqueParties } from '@/actions'
import { TITLE_BREAKDOWN_PROCESSING } from '@/constants'


export const useRealtimeTitleBreakdownStatus = (titleBreakdownId, runsheetId, runsheetTabId, setHasRecentFailure) => {
    const notifications = useWireValue(store.notifications)
    const [titleBreakdownStore, setTitleBreakdownStore] = useWireState(store.titleBreakdown)
    const remoteConfig = useWireValue(store.remoteConfig)
    
    useEffect(() => {
        
        if (!remoteConfig?.realtimeEnabled) return
        if (!titleBreakdownId) return
        
        const updateTitleBreakdownStatus = async () => {
            const latestNotification = notifications
                .filter(
                    notification =>
                        notification.message.data.type === RT_EVENT_TYPE_UPDATE_TITLE_BREAKDOWN_STATUS &&
                        notification.message.data.data.titleBreakdownId === titleBreakdownId,
                )
                .sort((a, b) => new Date(b.message.data.data.createdAt) - new Date(a.message.data.data.createdAt))[0]
            
            if (!latestNotification) return
            
            const { status: latestStatus } = latestNotification.message.data.data
            
            setTitleBreakdownStore({
                ...titleBreakdownStore,
                status: latestStatus,
            })
            
            if (!titleBreakdownStore || !TITLE_BREAKDOWN_PROCESSING.includes(latestStatus)) {
                const title = await fetchTitleBreakdown(runsheetId, runsheetTabId)
                
                setTitleBreakdownStore(title)
                setHasRecentFailure?.(title.hasRecentFailure)
                await listUniqueParties(runsheetId)
            }
        }
        
        updateTitleBreakdownStatus()
    }, [titleBreakdownId, runsheetId, runsheetTabId, notifications])
}
